import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../hooks/useRefreshToken";
import useAuth from "../hooks/useAuth";
import { Loader, SpinnerIcon } from "../Styles";

function PersistLogin() {
  const [isLoading, setIsLoading] = useState(true);
  const refresh = useRefreshToken();
  const { auth, isAuthenticated } = useAuth();

  useEffect(() => {
    let isMounted = true;

    const verifyRefreshToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.error(err);
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    // isAuthenticated added here to avoid unwanted call to verifyRefreshToken
    if (!auth?.accessToken && isAuthenticated) {
      verifyRefreshToken();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMounted = false;
      return isMounted;
    };
  }, []);

  /*
  useEffect(() => {
    console.log(`isLoading: ${isLoading}`);
    console.log(`aT: ${JSON.stringify(auth?.accessToken)}`);
  }, [isLoading]);
*/

  if (!isAuthenticated) {
    return <Outlet />;
  }

  if (isLoading) {
    return (
      <Loader>
        <SpinnerIcon size={60} />
      </Loader>
    );
  }

  return <Outlet />;
}

export default PersistLogin;
